/**
 * Estilo de contingência, usado apenas quando nenhum mapa-base está configurado.
 * As camadas da Geo-Engine continuam sendo desenhadas sobre este fundo.
 */
export const ESTILO_MINIMO = {
    version: 8,
    sources: {},
    layers: [
        {
            id: 'fundo',
            type: 'background',
            paint: { 'background-color': '#e8ede5' },
        },
    ],
};
/**
 * Câmera inicial.
 *
 * Dependência registrada — extensão territorial inicial:
 *
 *   O contrato público da Geo-Engine consumido por este Viewer
 *   (`GET /camadas`, `GET /camadas/{id}/estatisticas`) não expõe uma
 *   extensão territorial inicial global nem marca explicitamente uma
 *   camada publicada como base canônica. Conforme as regras vigentes
 *   sobre enquadramento territorial inicial, mantemos uma vista neutra
 *   enquanto esse contrato não for publicado.
 *
 *   Quando a Geo-Engine oferecer:
 *     - um endpoint próprio de extensão inicial
 *       (ex.: `GET /extensao-inicial`), ou
 *     - um marcador explícito em `Camada` que identifique a base
 *       territorial sem heurística por nome/ID,
 *   este fallback deve ser substituído pela resposta real da API.
 *   Não agregar indiscriminadamente extensões das camadas publicadas
 *   para iniciar em escala nacional.
 */
export const CENTRO_INICIAL = [-60, -15];
export const ZOOM_INICIAL = 3;
